import { makeStyles } from 'tss-react/mui';

import { isLightMode } from 'pages/Landings/utils';

export default makeStyles({ name: 'SubMenuItem' })((theme) => {
    return {
        root: {
            display: 'flex',
            padding: 16,
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 20,
            flex: '1 0 0',
            borderRadius: 8,
            transition: 'all 0.2s',
            textDecoration: 'none',
            '&:hover': {
                background: isLightMode(theme) ? 'rgba(0, 0, 0, 0.05)' : '#FFFFFF0D'
            },
            '&:active': {
                background: isLightMode(theme) ? 'rgba(0, 0, 0, 0.05)' : '#FFFFFF0D'
            }
        },
        icon: {
            lineHeight: 0,
            width: 40,
            height: 40,
            '& > svg': {
                width: '100%',
                height: '100%'
            }
        },
        text: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 8
        },
        title: {
            color: isLightMode(theme) ? '#232323' : '#fff',
            fontSize: 18,
            fontWeight: 500,
            lineHeight: '20px'
        },
        subtitle: {
            color: isLightMode(theme) ? '#6B6B6B' : '#8E8E8E',
            fontSize: 14,
            fontWeight: 500,
            lineHeight: '20px'
        }
    };
});
